import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-font-panel-italic-active",
  "use": "icon-font-panel-italic-active-usage",
  "viewBox": "0 0 11 14",
  "content": "<symbol viewBox=\"0 0 11 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-font-panel-italic-active\">\n<path d=\"M2.31261 0H11V1.56H7.50091L5.1883 12.44H8.68739V14H0V12.44H3.49909L5.8117 1.56H2.31261V0Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol